import React from 'react'
import { StyledBox, StyledBoxWrapper, StyledTextField } from './styles'
import PreparedQuestionCardDropDownMenu from '../PreparedQuestionCardWrapper/PreparedQuestionCardDropDownMenu'
import { useDispatch } from 'react-redux'
import { type DescriptiveQuestion } from '../../../types'
import { getEditableQuestion, getSelectedQuestion } from '../../../../../store/slices/SurveyTemplateSlice/selectors'
import { type ISurveySection, setEditableQuestion } from '../../../../../store/slices/SurveyTemplateSlice'
import { StyledFormLabel } from '../FreeResponseCard/styles'
import { InvalidQuestionError } from '../../../../SurveyFeature/styles'
import { red } from '../../../../../colors'

interface DescriptiveTextCardProps {
  question: DescriptiveQuestion
  index: number
  sectionIndex: number
  totalQuestionInSection: number
  section: ISurveySection
  invalidQuestionItemId?: string
}
const DescriptiveTextCard: React.FC<DescriptiveTextCardProps> = ({ question, index, sectionIndex, totalQuestionInSection, section }): JSX.Element => {
  const dispatch = useDispatch()
  const editableQuestion = getEditableQuestion()
  const selectedQuestion = getSelectedQuestion()

  const handleEditableQuestion = (): void => {
    if (editableQuestion == null && !selectedQuestion) {
      dispatch(setEditableQuestion({ question, questionIndex: index, sectionIndex }))
    }
  }

  return (
    <StyledBoxWrapper
      id={question?.itemId}
    >
      <StyledBox onClick={handleEditableQuestion} id={`${sectionIndex}${index}`}>
        {question?.prompt !== ''
          ? <StyledFormLabel>{question.prompt}</StyledFormLabel>
          : <StyledTextField
              name='DescriptiveCard'
              type='text'
              placeholder='Add text here...'
              value={question?.prompt}
              fullWidth
            />
        }
      </StyledBox>
      <PreparedQuestionCardDropDownMenu question={question} questionIndex={index} sectionIndex={sectionIndex} totalQuestionInSection={totalQuestionInSection} section={section}/>
    </StyledBoxWrapper>
  )
}

export default DescriptiveTextCard
